import { render, staticRenderFns } from "./SamplesTable.vue?vue&type=template&id=a415e112&scoped=true&"
import script from "./SamplesTable.vue?vue&type=script&lang=js&"
export * from "./SamplesTable.vue?vue&type=script&lang=js&"
import style0 from "./SamplesTable.vue?vue&type=style&index=0&id=a415e112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a415e112",
  null
  
)

/* custom blocks */
import block0 from "./SamplesTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports